import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogOut, Home, LayoutDashboard, Bell, User } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { useTranslation } from '@/hooks/useTranslation';

const Header = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { currentLanguage } = useTranslation();

  const getPath = (path) => `/${currentLanguage}${path}`;

  const handleLogout = async () => {
    await logout();
    navigate(getPath('/system/login'));
  };

  return (
    <>
      <div className="h-1 w-full bg-gradient-to-r from-[#FBBF24] via-[#FCD34D] to-[#FBBF24]"></div>
      <header className="sticky top-0 z-50 w-full bg-[#193D6D] shadow-xl shadow-[#193D6D]/10" id="system-header">
        <div className="w-full px-4 md:px-6 flex h-16 items-center justify-between mx-auto">

          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={() => navigate(getPath(''))}
              className="flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-bold transition-all duration-300 border border-[#FCD34D]/50 text-[#FCD34D] hover:bg-[#FCD34D] hover:text-[#193D6D] hover:shadow-lg hover:shadow-[#FCD34D]/20 tracking-wider uppercase"
              id="header-home-btn"
              aria-label="Voltar ao início"
            >
              <Home className="h-4 w-4" />
              <span className="hidden sm:inline-block">Início</span>
            </button>

            <Link to={getPath('/sistema')} className="flex items-center gap-2 transition-colors text-white hover:text-[#FCD34D] group" aria-label="PROVATIO Sistema">
              <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center group-hover:bg-[#FCD34D]/20 transition-all duration-300 border border-white/10 group-hover:border-[#FCD34D]/30">
                <span className="text-[16px]">🔬</span>
              </div>
              <span className="font-bold text-lg hidden md:block tracking-wider" style={{ fontFamily: "'Outfit', sans-serif" }}>PROVATIO</span>
            </Link>
          </div>

          <div className="flex items-center gap-2 md:gap-3 flex-shrink-0">
            {/* Notifications */}
            <button
              className="relative p-2.5 rounded-full transition-all duration-300 text-white/60 hover:text-[#FCD34D] hover:bg-white/10"
              aria-label="Notificações"
              id="header-notifications-btn"
            >
              <Bell className="h-5 w-5" />
              <span className="absolute top-1.5 right-1.5 w-2.5 h-2.5 bg-[#FCD34D] rounded-full border-2 border-[#193D6D]"></span>
            </button>

            <div className="h-6 w-[1px] bg-white/15 mx-1"></div>

            {/* User Profile */}
            <div className="flex items-center gap-2 group cursor-pointer">
              <div className="text-right hidden sm:block">
                <p className="text-xs font-semibold text-white leading-none">{user?.email?.split('@')[0] || 'Admin'}</p>
                <p className="text-[10px] text-[#FCD34D]/70 mt-0.5 uppercase tracking-wider font-bold">{user?.role || 'Perito'}</p>
              </div>
              <div className="w-9 h-9 rounded-full bg-white/10 border border-white/10 flex items-center justify-center text-white font-bold overflow-hidden group-hover:border-[#FCD34D]/30 transition-all">
                <User size={18} />
              </div>
            </div>

            <Link
              to={getPath('/sistema')}
              className="hidden sm:flex items-center gap-2 px-5 py-2 rounded-full font-bold text-xs transition-all duration-300 bg-[#FCD34D] text-[#193D6D] hover:bg-[#FBBF24] hover:shadow-lg hover:shadow-[#FCD34D]/20 tracking-wider uppercase"
              id="header-system-btn"
            >
              <LayoutDashboard className="h-3.5 w-3.5" />
              SISTEMA
            </Link>

            <button
              onClick={handleLogout}
              className="p-2.5 rounded-full transition-all duration-300 text-white/50 hover:text-red-400 hover:bg-red-400/10"
              title="Sair"
              aria-label="Sair do sistema"
              id="header-logout-btn"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;